import moment from "moment";

import blog1Image from "src/shared/assets/blogs/blog1.webp";
import blog2Image from "src/shared/assets/blogs/blog2.webp";
import blog3Image from "src/shared/assets/blogs/blog3.webp";

export const blogCardsMock = [
  {
    title: "Answer Distribution Depending on Temperature",
    description:
      "How randomness in AI answers shifts with every tweak — and why it matters for trust.",
    image: blog1Image,
    createdAt: moment(),
    linkedinURL: "some string",
    readMinutes: moment(),
    blogURL: "some string",
  },
  {
    title: "Broken Attention make hallucinations",
    description:
      "When AI loses focus, facts fall apart. Discover why broken attention leads to bold mistakes.",
    image: blog2Image,
    createdAt: moment(),
    linkedinURL: "some string",
    readMinutes: moment(),
    blogURL: "some string",
  },
  {
    title: "Long Context Degradation",
    description:
      "The longer the story, the blurrier the truth. Explore how AI forgets over time — and solutions ahead.",
    image: blog3Image,
    createdAt: moment(),
    linkedinURL: "some string",
    readMinutes: moment(),
    blogURL: "some string",
  },
];
